// extracted by mini-css-extract-plugin
export default {"root":"TextBox_root__2Il2p","input":"TextBox_input__PFAZb"};